import React from 'react';

// Keep intrinsic proportions and small images at their original size.
const StickerImage = ({ src, alt = 'Sticker' }) => (
  <img
    src={src}
    alt={alt}
    className="block w-auto h-auto max-w-[150px] max-h-[150px] object-contain"
    draggable={false}
    loading="lazy"
    data-testid="sticker-image"
  />
);

export default StickerImage;
